







































































import Vue              from 'vue'
import {Component}      from 'vue-property-decorator'
import CustomButton     from '@/components/CustomButton.vue'
import CustomInput      from '@/components/CustomInput.vue'
import bgSlide          from '@/assets/img/bg_slide.png'
import imgLogo          from '@/assets/img/logo-branco-full.png'
import {auth, sendCode} from '@/common/api'
import SVGIcon          from '@/components/SVGIcon.vue'

const STEP_ID = 'id'
const STEP_PIN = 'pin'

@Component({
    components: {SVGIcon, CustomInput, CustomButton}
})
export default class Login extends Vue {
    protected STEP_ID: string = STEP_ID
    protected STEP_PIN: string = STEP_PIN

    protected bgSlide: string = bgSlide
    protected imgLogo: string = imgLogo
    protected step: string = STEP_ID

    protected loading: boolean = false
    protected credentials = {
        document: '',
        contact: '',
        code: ''
    }

    protected async sendCode(e: Event) {
        e.preventDefault()

        try {
            this.loading = true
            await sendCode(this.credentials)
            this.step = STEP_PIN
        } catch (e) {
            this.$msgError('Erro', e.message)
        } finally {
            this.loading = false
        }
    }

    protected async auth(e: Event) {
        e.preventDefault()

        const {credentials} = this

        if (!credentials.code) {
            this.$msgError('Erro', 'Informe o código de verificação.')
        }

        try {
            this.loading = true
            await auth(credentials)
            this.$router.push('/home')
        } catch (e) {
            this.$msgError('Erro', e.message)
        } finally {
            this.loading = false
        }
    }
}
